import React, { forwardRef } from 'react';
import { Input } from 'antd';
import styles from '../RemoveTenantFromRoomModal.module.scss';

const ReadingInput = forwardRef(({ onChange, value }, ref) => {
  const triggerChange = (changedValue) => {
    if (onChange) {
      onChange({
        ...value,
        ...changedValue,
      });
    }
  };

  const handleReadingChange = (e) => {
    triggerChange({ reading: e.target.value });
  };

  return (
    <div ref={ref}>
      <Input value={value.id} hidden />
      <Input
        value={value.reading}
        onChange={handleReadingChange}
        className={styles.meterField}
      />
    </div>
  );
});

export default ReadingInput;
